<template>

  <div>

    <vs-input
      :label="label"
      :readonly="readonly"
      v-model="masked"
      v-validate="required ? 'required' : ''"
      :label-placeholder="labelPlaceholder"
      :placeholder="placeholder"
      :name="name"
      :class="cssClasses"
      v-on:blur="update"
      :disabled="disable"
    />
    <span
      v-if="required"
      class="text-danger text-sm"
      v-show="errors.has(name)">{{ errors.first(name) }}</span>

  </div>

</template>

<script>

export default {
  name: 'CnpjInput',
  props: {
    label: {
      default: '',
      type: [String]
    },
    // Aceita String (alfanumérico) ou Number (legado numérico).
    value: {
      default: '',
      type: [String, Number]
    },
    name: {
      default: null,
      type: [String]
    },
    readonly: {
      default: false,
      type: [String, Boolean]
    },
    right: {
      default: false,
      type: [String, Boolean]
    },
    disable: {
      default: false,
      type: [String, Boolean]
    },
    placeholder: {
      default: '',
      type: [String]
    },
    labelPlaceholder: {
      default: '',
      type: [String]
    }
  },
  data () {
    return {
      masked: '',
      required: false
    }
  },
  beforeMount () {
    this.required = this.name != null
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.masked = this.format(val)
      }
    }
  },
  computed: {
    cssClasses () {
      return this.right ? 'w-full text-right' : 'w-full'
    }
  },
  methods: {
    // Mantém apenas 0-9 e A-Z, uppercase, no máximo 14 posições.
    normalize (val) {
      if (val === null || val === undefined) {
        return ''
      }
      return String(val).toUpperCase().replace(/[^0-9A-Z]/g, '').slice(0, 14)
    },
    format (val) {
      const raw = this.normalize(val)
      if (raw === '') {
        return ''
      }
      return raw.replace(
        /^([0-9A-Z]{2})([0-9A-Z]{3})?([0-9A-Z]{3})?([0-9A-Z]{4})?(\d{2})?/,
        (match, p1, p2, p3, p4, p5) => {
          let out = p1
          if (p2) out += '.' + p2
          if (p3) out += '.' + p3
          if (p4) out += '/' + p4
          if (p5) out += '-' + p5
          return out
        }
      )
    },
    update () {
      const raw = this.normalize(this.masked)
      this.masked = this.format(raw)
      // Emite a string crua (sem máscara, uppercase) — fonte de verdade alfanumérica.
      this.$emit('input', raw)
    }
  }
}
</script>

<style scoped>
.text-align-right {
  text-align: right;
}
</style>
